import { tw } from "@careinfo/tailwind";
import { Control, Controller } from "react-hook-form";
import { PhoneInput } from "react-international-phone";
import "./style.css";

interface Props {
  control: Control<any, any>;
  name: string;
  errors: any;
  label: string;
  disabled?: boolean;
}

const PhoneNumberField = ({
  control,
  name,
  errors,
  label,
  disabled = false,
}: Props) => {
  return (
    <div className={tw`w-full my-2 text-left mt-2`}>
      <label
        style={{
          flex: "none",
          opacity: disabled ? 0.6 : 1,
          pointerEvents: disabled ? "none" : "auto",
        }}
      >
        <span>{label}</span>

        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <PhoneInput
              {...field}
              disabled={disabled}
              className={tw`w-full focus:outline-none bg-[#EEF5F4] mt-1`}
              inputStyle={{
                backgroundColor: "inherit",
                border: "none",
                width: "100%",
              }}
              countrySelectorStyleProps={{
                buttonStyle: { backgroundColor: "inherit" },
                dropdownStyleProps: {
                  listItemClassName: tw`border`,
                },
              }}
              defaultCountry="np"
              value={field.value || ""}
              onChange={(value) => field.onChange(value)}
            />
          )}
        />
      </label>

      {errors && (
        <p className={tw`text-red-500 text-xs my-1`}>{errors?.message}</p>
      )}
    </div>
  );
};

export default PhoneNumberField;
